module.exports = __webpack_public_path__ + "img/RedLightAnimationv2.dd9466f8.gif";